export const identityUrl = (isSsoVerify: boolean): string => {
  const match = window.location.origin.match(/pr[0-9]+/);
  if (match != null) {
    return isSsoVerify ? `https://sso-${match[0]}.zvoove-dev.cloud` : 'https://sso.zvoove-dev.cloud';
  }
  return `https://sso.${new URL(window.location.origin).hostname.split('.').slice(1).join('.')}`;
};

export const backendUrl = (): string => `${window.location.origin}/api`;
export const communicationUrl = (): string =>
  `https://communication.${new URL(window.location.origin).hostname.split('.').slice(1).join('.')}`;
